/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ delta: NonNullable<unknown> }} Body_Assessment_Compare_Delta_BodyfatInputs */

const en_us2_body_assessment_compare_delta_bodyfat = /** @type {(inputs: Body_Assessment_Compare_Delta_BodyfatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Body fat: ${i?.delta} pp`)
};

const pt_br2_body_assessment_compare_delta_bodyfat = /** @type {(inputs: Body_Assessment_Compare_Delta_BodyfatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gordura corporal: ${i?.delta} p.p.`)
};

const es_419_body_assessment_compare_delta_bodyfat = /** @type {(inputs: Body_Assessment_Compare_Delta_BodyfatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Grasa corporal: ${i?.delta} p. p.`)
};

const pt_pt2_body_assessment_compare_delta_bodyfat = /** @type {(inputs: Body_Assessment_Compare_Delta_BodyfatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gordura corporal: ${i?.delta} p.p.`)
};

const fr_fr2_body_assessment_compare_delta_bodyfat = /** @type {(inputs: Body_Assessment_Compare_Delta_BodyfatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Masse grasse : ${i?.delta} pts`)
};

const de_de2_body_assessment_compare_delta_bodyfat = /** @type {(inputs: Body_Assessment_Compare_Delta_BodyfatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Körperfett: ${i?.delta} Pp.`)
};

const it_it2_body_assessment_compare_delta_bodyfat = /** @type {(inputs: Body_Assessment_Compare_Delta_BodyfatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Grasso corporeo: ${i?.delta} p.p.`)
};

/**
* | output |
* | --- |
* | "Body fat: {delta} pp" |
*
* @param {Body_Assessment_Compare_Delta_BodyfatInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_compare_delta_bodyfat = /** @type {((inputs: Body_Assessment_Compare_Delta_BodyfatInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Compare_Delta_BodyfatInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_compare_delta_bodyfat(inputs)
	if (locale === "es-419") return es_419_body_assessment_compare_delta_bodyfat(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_compare_delta_bodyfat(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_compare_delta_bodyfat(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_compare_delta_bodyfat(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_compare_delta_bodyfat(inputs)
	return en_us2_body_assessment_compare_delta_bodyfat(inputs)
});
export { body_assessment_compare_delta_bodyfat as "body-assessment.compare_delta_bodyfat" }